import { AvailableCountries } from '../../../globalTypes'
import { CSSProperties } from 'react'
import { DE, DK, FI, GB, NO, SE } from 'country-flag-icons/react/3x2'

const CountryFlagIcon = ({
  country,
  styles = {},
}: {
  country: AvailableCountries
  styles?: CSSProperties
}) => {
  const iconStyles = { ...{ height: '20px', borderRadius: 2 }, ...styles }

  switch (country.toUpperCase()) {
    case 'DK':
      return <DK style={iconStyles} />
    case 'SE':
      return <SE style={iconStyles} />
    case 'NO':
      return <NO style={iconStyles} />
    case 'FI':
      return <FI style={iconStyles} />
    case 'UK':
      return <GB style={iconStyles} />
    case 'DE':
      return <DE style={iconStyles} />
    default:
      break
  }
}

export default CountryFlagIcon
